export * from './baMsgCenter.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baMsgCenter/index.ts